import { makeStyles, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";
import ILocationAPIObject from "../../interfaces/ILocationAPI";
import IVenue from "../../yoello-lib/modules/API/interfaces/IVenue";

interface IVenueTitle {
    venue: IVenue;
    location: ILocationAPIObject;
    /**Deafult to false */
    isLoading?: boolean;
}

const useStyles = makeStyles({
    title: {
        fontWeight: 700,
        fontSize: '1rem',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow:'hidden'
    },
    text: {
        fontSize: '0.8rem',
        color: '#757575',
        paddingBottom: '0.1rem'
    }
})
export function VenueTitle({
    location,
    venue,
    isLoading = true
}: IVenueTitle) {
    const classNames = useStyles();
    function venueLocationString() {
        let venueLocation = "";
        if (location?.address_number) {
            venueLocation += location?.address_number + " ";
        }
        if (location?.address_building) {
            venueLocation += location?.address_building + " ";
        }
        if (location?.address_postcode) {
            venueLocation += location?.address_postcode + " ";
        }
        return venueLocation;
    }
    return <>
        <Typography data-component-name="VenueName" className={classNames.title}>
            {isLoading ? <Skeleton variant="text" width={"80%"} height={25} animation="wave" />
                : venue?.venue_name}
        </Typography>
        <Typography noWrap className={classNames.text}>
            {isLoading ? <Skeleton variant="text" height={20} animation="wave" /> : venueLocationString()}
        </Typography>
    </>
}